document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.dj-collection').forEach(function (section) {

    // Tab switching
    var tabs = section.querySelectorAll('.dj-collection__tab');
    var shopAllBtn = section.querySelector('.dj-collection__shopall');

    function updateShopAllLink(tab) {
      if (!shopAllBtn || !tab) return;
      var collectionUrl = tab.getAttribute('data-tab-collection');
      var collectionTitle = tab.getAttribute('data-collection-title');
      if (collectionUrl) {
        shopAllBtn.setAttribute('href', collectionUrl);
        shopAllBtn.textContent= 'Shop All ' + collectionTitle;
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-tab-target');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        section.querySelectorAll('.dj-collection__panel').forEach(function (panel) {
          panel.classList.toggle('is-active', panel.id === targetId);
        });

        updateShopAllLink(tab);
      });
    });

    // Set the correct link on initial load, based on whichever tab starts active
    var initialActiveTab = section.querySelector('.dj-collection__tab.is-active') || tabs[0];
    updateShopAllLink(initialActiveTab);

    // Carousel arrows
    section.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      function scrollAmount() {
        var card = track.querySelector('.dj-card');
        return card ? card.getBoundingClientRect().width + 16 : 300;
      }

      function updateArrowState() {
        var maxScroll = track.scrollWidth - track.clientWidth;
        var buffer = 2;

        if (maxScroll <= buffer) {
          if (prevBtn) prevBtn.disabled = true;
          if (nextBtn) nextBtn.disabled = true;
          return;
        }

        if (prevBtn) prevBtn.disabled = track.scrollLeft <= buffer;
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll - buffer;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrowState);
      window.addEventListener('resize', updateArrowState);

      updateArrowState();
      window.addEventListener('load', updateArrowState);
    });
  });
});